if (window.Handlebars) {
	Handlebars.registerHelper("roundTime", function(time, key) {
		var t = moment.duration(time);
		if (["mm", "minuti"].indexOf(key.toLowerCase()) !== -1)
	    	t = t.asMinutes();
	    else if (["hh", "ore"].indexOf(key.toLowerCase()) !== -1)
	    	t = t.asHours();
	    return Math.round(t);
	});
}


// WEBPACK FOOTER //
// ./../../../rairadio/template/helpers/time-helper.js